import React, { Component, useEffect, useState } from 'react';
import Header from '../Components/Header';
import Footer from '../Components/Footer';
import { useTranslation } from "react-i18next";
import "../translations/i18n";
import {  useSelector } from 'react-redux';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { transLabel } from '../translations/util';
import { useCookies } from 'react-cookie';


const Home = () => {
    const translations = useSelector(state => state.translationReducer);
    const [translation, setTranslation] = useState([]);
    const [cookies, setCookie] = useCookies(['languaje']);
    const navigate = useNavigate();
    let lan = (cookies.languaje==null)?"ES":cookies.languaje;
    const [searchParams, setSearchParams] = useSearchParams();
    
    const toPage= (page) => {
        navigate(page) 
    }

    useEffect(() => {
        setTranslation(translations.data);
      }, [translations]);

    const { t } = useTranslation();
        return (
            <>
                <Header />
                    <div id="banner" className="container-fluid">
                            <div className="row">
                                <div className="col-md-4 offset-md-2">
                                    <img src="assets/img/capital-letter-ethics-channel-ayesa.png"/>
                                    <h1>{transLabel("header.title")}</h1>
                                </div>          
                            </div>
                    </div>
                    <div className="container">
                        <div className="row">
                            <div id="intro" className="col-lg-7" dangerouslySetInnerHTML={{ __html: transLabel("home.intro")}}>
                            </div>
                            <div id="intro-sidebar" className="col-lg-4 offset-lg-1 align-self-center">
                                <a href="#" onClick={(e)=>{toPage("/registration");}} style={{backgroundImage:"url(assets/img/menu-intro-01.svg)"}}>{transLabel("home.btnNewCase")}</a>
                                <a href="#" onClick={(e)=>{toPage("/login");}} style={{backgroundImage:"url(assets/img/menu-intro-02.svg)"}}>{transLabel("home.btnQuery")}</a>

                                <a href="#" style={{display:"none",backgroundImage:"url(assets/img/menu-intro-03.svg)"}}></a>
                                
                                <div dangerouslySetInnerHTML={{ __html: transLabel("home.btnDownload")}}>
                                    
                                </div>
                            
                            </div>
                        </div>
                    </div>                
                <Footer />
            </>
        );
}

export default Home;